<app-navbar [title]="'Operacje na transakcjach (Kto rozliczył)'"> </app-navbar>

<app-dynamic-table module="bankHistoryOperations" [elements]="data" [tableRows]="tableRows"></app-dynamic-table>
